<template lang="">
    <div class="flex flex-wrap w-full justify-center items-center">
       <div class="w-full lg:container lg:mx-auto bg-white">
            <section>
                <div class="pt-2 pb-1 border-b-4 border-yellow-300">
                    <div class="text-gray-800 font-semibold flex items-center justify-start">
                        <router-link
                            to='/report'>
                            <div class="text-lg lg:text-2xl pt-2 pb-2 px-4">Отчеты</div>
                        </router-link>
                    </div>
                </div>
            </section>
            <section>
                <div class="flex flex-wrap">
                    <div v-for="nav, index in navs" class="w-1/2 lg:w-1/3 p-4" :key="index">
                        <div>{{ nav.title }}</div>
                        <div v-for="ni, index in nav.items" :key="index">
                            <div v-if="ni.inactive" class="hidden md:flex flex-col px-8 py-16 mb-4 rounded-md bg-gray-50 border opacity-100" active-class="bg-lime-300">
                                <div class="text-xl text-center h-7"></div>
                            </div>
                            <router-link v-else :to="ni.to" class="flex flex-col px-8 py-16 mb-4 items-center justify-center hover:bg-lime-300 cursor-pointer rounded-md bg-white border shadow-md main-nav h-40" active-class="bg-lime-300">
                                <div class="text-xl text-center ">{{ ni.title }}</div>
                                <div class="text-sm text-center text-gray-500">{{ ni.description }}</div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>
       </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            navs: [
                {
                    // category
                    title: '',
                    items:
                    [
                        {
                            title: 'Итоги дня',
                            to: { name: 'DailyReportTotals', params: { day: 'сегодня', sector: 'orders_summs' } }
                        },
                        {
                            title: 'Заказы дня',
                            to: { name: 'DailyReportOrders', params: { day: 'сегодня', sector: 'orders_list', show_criteria: 'active', show_value: 'all' } }
                        },
                        {
                            inactive: true
                        }
                    ]
                },
                {
                    // category
                    title: '',
                    items:
                    [
                        {
                            title: 'Итоги месяца',
                            to: { name: 'MonthlyReport' }
                        },
                        {
                            inactive: true
                        },
                        {
                            inactive: true
                        }
                    ]
                },
                {
                    // category
                    title: '',
                    items:
                    [
                        {
                            title: 'Поиск заказов',
                            to: { name: 'FilteredOrders' }
                        },
                        {
                            title: 'Поиск заказов по номеру',
                            to: { name: 'FilteredOrdersById' }
                        },
                        {
                            inactive: true
                        }
                    ]
                }
            ]
        }
    },
    methods: {
    },
    watch: {
    },
    mounted () {
    },
    components: {
    }
}
</script>
<style scoped>
.main-nav{
    background-image: url('https://img.icons8.com/nolan/256/1A6DFF/C822FF/graph-report.png');
    background-repeat: no-repeat;
    background-size: 90px;
    background-position: -45px center;
    /* text-shadow: 1px 1px 1px #fff, -1px -1px 1px #fff, -1px 1px 1px #fff, 1px -1px 1px #fff; */
}
</style>
